import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { BaseHttpService } from '../../services/common/base.http.service';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { administrationConst } from '../administration.const';
import { ResultInfo } from '../../shared/models/result-info.model';
import { TreasuryRateModel } from '../models/treasury-rate.model';
import { ManageTreasuryRateModel } from '../models/manage-treasury-rate.model';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';

@Injectable({
  providedIn: 'root'
})
export class TreasuryRateService {
  baseHttpService = inject(BaseHttpService);
  loggedInUserService = inject(LoggedInUserService);
  
  searchTreasuryRate(data: SearchParameters<TreasuryRateModel>): Observable<PagedResult<TreasuryRateModel[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<PagedResult<TreasuryRateModel[]>>(administrationConst.treasuryRate, data, { headers: headers });
  }

  getTreasuryRate(id: number): Observable<TreasuryRateModel> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });    
    return this.baseHttpService.get<TreasuryRateModel>(administrationConst.treasuryRate + "/" + id, { headers: headers });
  }

  searchAllTreasuryRate(email: string, pageSize: number): Observable<PagedResult<TreasuryRateModel[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const params = `?email=${email}&pageSize=${pageSize}`;
    return this.baseHttpService.get<PagedResult<TreasuryRateModel[]>>(administrationConst.treasuryRate + params, { headers: headers });
  }

  addTreasuryRate(data: ManageTreasuryRateModel): Observable<ResultInfo> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<ResultInfo>(administrationConst.treasuryRateAdd, data, { headers: headers });
  }

  updateTreasuryRate(data: ManageTreasuryRateModel): Observable<ResultInfo> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.put<ResultInfo>(administrationConst.treasuryRate, data, { headers: headers });
  }

  deleteTreasuryRate(data: ManageTreasuryRateModel): Observable<ResultInfo> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.put<ResultInfo>(administrationConst.treasuryRateDelete, data, { headers: headers });
  }  
}